import { Box, styled, StyleSystemProps } from '@withjoy/joykit';
export const StyledWrapper = styled(Box)``;
export const StyledMainSection = styled(Box)``;

const wrapperNewMvpStyles: StyleSystemProps = {
  width: '100%',
  maxWidth: '100%',
  paddingX: {
    _: 4,
    sm2: 6,
    md2: 8,
    lg: 10,
  },
};

const mainSectionStyles: StyleSystemProps = {
  flex: '1 auto',
  marginX: {
    _: 0,
    sm2: 8,
  },
};

export const styles = {
  wrapperNewMvp: wrapperNewMvpStyles,
  mainSection: mainSectionStyles,
};
